"use client";

/* eslint-disable jsx-a11y/iframe-has-title */
import { FC, useEffect, useRef } from "react";
import { HubspotFormSectionRecord } from "@graphql/types/graphql";
import { Container } from "components/organisms/Container/Container";

interface Props {
  data: HubspotFormSectionRecord;
}

export const HubspotFormSection: FC<Props> = ({ data }) => {
  const formRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!formRef.current) return;

    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.async = true;
    script.onload = () => {
      (window as any).hbspt.forms.create({
        region: "eu1",
        portalId: data.portalId,
        formId: data.formId,
        target: `#hubspot-form-${data.formId}`,
      });
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [data.portalId, data.formId]);

  return (
    <Container>
      <div ref={formRef} id={`hubspot-form-${data.formId}`} />
    </Container>
  );
};
